export default "__VITE_ASSET__QLP_dRot__"